import {
  ColorButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
} from 'ra-input-rich-text'
import React from 'react'
import { RAInputProps } from 'types/common'

const KToolbar: React.FC = () => (
  <div style={{ display: 'flex', padding: '5px', gap: '5px' }}>
    <LevelSelect />
    <FormatButtons />
    <ColorButtons />
    <ListButtons />
    <LinkButtons />
    <QuoteButtons />
  </div>
)

const KRichTextInput: React.FC<RAInputProps> = (props) => {
  return <RichTextInput {...props} toolbar={<KToolbar />} />
}

export default KRichTextInput
